import { useState } from "react";
import { useReveal } from "../hooks";

const SALES_PER_REP = 18;
const fmt = (n) => "$" + Math.round(n).toLocaleString("en-CA");

export const Calculator = () => {
  const [ref, inView] = useReveal(0.2);
  const [reps, setReps] = useState(6);
  const [avgSale, setAvgSale] = useState(1200);
  const [months, setMonths] = useState(6);

  const monthly = reps * SALES_PER_REP * avgSale;
  const total = monthly * months;
  const acquisitions = reps * SALES_PER_REP * months;
  const bars = Array.from({ length: months }, (_, i) => ((i + 1) / months) * 100);

  return (
    <section className="sec calc" id="calculator" data-testid="calculator-section" ref={ref}>
      <div className="container">
        <div className={`reveal ${inView ? "in" : ""}`}>
          <span className="eyebrow light">Revenue calculator</span>
          <h2 className="h-display">What could Swift generate for you?</h2>
          <p className="lead" style={{ color: "rgba(255,255,255,0.6)" }}>
            Drag the sliders. The projection is based on average Swift rep performance
            across our telecom and energy divisions.
          </p>
        </div>
        <div className={`calc-grid reveal d2 ${inView ? "in" : ""}`}>
          <div className="calc-sliders">
            <div className="calc-slider">
              <label><span>Reps deployed</span><b data-testid="calc-reps-value">{reps} reps</b></label>
              <input type="range" min="2" max="30" value={reps} onChange={(e) => setReps(+e.target.value)} data-testid="calc-reps-slider" />
            </div>
            <div className="calc-slider">
              <label><span>Average sale value</span><b data-testid="calc-sale-value">{fmt(avgSale)}</b></label>
              <input type="range" min="200" max="5000" step="50" value={avgSale} onChange={(e) => setAvgSale(+e.target.value)} data-testid="calc-sale-slider" />
            </div>
            <div className="calc-slider">
              <label><span>Engagement length</span><b data-testid="calc-months-value">{months} {months === 1 ? "month" : "months"}</b></label>
              <input type="range" min="1" max="24" value={months} onChange={(e) => setMonths(+e.target.value)} data-testid="calc-months-slider" />
            </div>
            <p className="calc-note">
              Assumes {SALES_PER_REP} closed sales per rep per month — the average across
              Swift field teams. Actual results depend on offer, territory, and season.
              Remember: you only pay on what we close.
            </p>
          </div>
          <div className="calc-result" data-testid="calc-result">
            <div className="calc-total-label">Projected revenue</div>
            <div className="calc-total" data-testid="calc-total">{fmt(total)}</div>
            <div className="calc-mini">
              <div><div className="v">{fmt(monthly)}</div><div className="k">Monthly run-rate</div></div>
              <div><div className="v">{acquisitions.toLocaleString()}</div><div className="k">Customer acquisitions</div></div>
            </div>
            <div className="calc-bars">
              {bars.map((h, i) => <i key={i} style={{ height: `${h}%` }} />)}
            </div>
            <a href="#qualify" className="btn" style={{ marginTop: 34 }} data-testid="calc-cta">Make it real →</a>
          </div>
        </div>
      </div>
    </section>
  );
};
